import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '@/lib/api';
import { Swords, ArrowRight, Sparkles } from 'lucide-react';

export default function BattleWidget() {
  const [battle, setBattle] = useState(null);
  const [mult, setMult] = useState(null);

  useEffect(() => {
    api.get('/battles/current').then(r => {
      setBattle(r.data.battle);
      setMult(r.data.multiplier);
    }).catch(() => {});
  }, []);

  if (!battle) return null;

  return (
    <Link
      to="/battles"
      className="block bg-gradient-to-br from-[#FCD535]/12 via-[#181A20] to-[#181A20] border border-[#FCD535]/30 p-5 hover:border-[#FCD535]/60 transition-colors group"
      data-testid="battle-widget"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Swords className="w-4 h-4 text-[#FCD535]" />
          <div className="text-xs uppercase tracking-widest text-[#848E9C]">Coin Battle · This Week</div>
        </div>
        <ArrowRight className="w-3.5 h-3.5 text-[#848E9C] group-hover:text-[#FCD535]" />
      </div>
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          {battle.coin_a?.image && <img src={battle.coin_a.image} alt="" className="w-8 h-8" />}
          <div className="min-w-0">
            <div className="text-white text-sm font-semibold truncate">{battle.coin_a?.symbol}</div>
            <div className="text-xs font-mono text-[#848E9C]">{battle.pct_a}%</div>
          </div>
        </div>
        <div className="text-[#FCD535] font-display font-bold text-lg">VS</div>
        <div className="flex items-center gap-2 flex-1 min-w-0 justify-end">
          <div className="min-w-0 text-right">
            <div className="text-white text-sm font-semibold truncate">{battle.coin_b?.symbol}</div>
            <div className="text-xs font-mono text-[#848E9C]">{battle.pct_b}%</div>
          </div>
          {battle.coin_b?.image && <img src={battle.coin_b.image} alt="" className="w-8 h-8" />}
        </div>
      </div>
      <div className="flex mt-3 h-1.5 bg-[#2B3139] overflow-hidden">
        <div className="bg-[#FCD535] h-full" style={{ width: `${battle.pct_a}%` }} />
        <div className="bg-[#5E6673] h-full" style={{ width: `${battle.pct_b}%` }} />
      </div>
      <div className="flex items-center justify-between mt-3">
        <div className="text-xs text-[#B7BDC6]">
          {battle.user_choice
            ? <span className="text-[#FCD535]">✓ Voted · {battle.hours_remaining}h left</span>
            : <span>Cast your vote — <span className="text-[#FCD535]">{battle.hours_remaining}h left</span></span>}
        </div>
        {mult?.active && (
          <div className={`flex items-center gap-1 text-[10px] font-mono uppercase ${mult.boosted ? 'text-[#F6465D]' : 'text-[#0ECB81]'}`}>
            <Sparkles className="w-3 h-3" /> {mult.boosted ? `+${Math.round((mult.value - 1) * 100)}% BOOSTED` : '+25% mult'}
          </div>
        )}
      </div>
    </Link>
  );
}
